import { useLocalStorage } from "usehooks-ts";

export const useInProgressValuesLocalCache = <T>(
  page:
    | "ShipperCargoCreatePage"
    | "ShipperContractCreatePage"
    | "CarrierDeliveryProposalCreatePage"
    | "MasterDataVehicleCreatePage"
    | "MasterDataVehicleDetailPage"
    | "AdminCargoCreatePage"
    | "AdminCargoDetailPage"
    | "AdminDeliveryProposalCreatePage"
    | "AdminDeliveryProposalDetailPage"
    | "AdminContractDetailPage",
) => {
  return useLocalStorage<T | undefined>(`${page}.inProgressValues`, undefined);
};
